module.exports = __webpack_public_path__ + "wordmark.cf6f41ef.svg";